const AUTHORIZATION_ERROR = 'Sorry, you don’t have permission to access this page.'
const INTERNAL_SERVER_ERROR = 'Sorry, we’re experiencing an internal server problem. Please try again later.'

const ALL = '.*'
const defaultErrorStatusMessageMap = {
    '403': AUTHORIZATION_ERROR,
    [ALL]: INTERNAL_SERVER_ERROR
}

export function getErrorMessage(status, errorStatusMessageMap) {
    const errorMap = Object.assign({}, defaultErrorStatusMessageMap, errorStatusMessageMap)

    const statusStr = status.toString()

    if (errorMap[statusStr]) {
        return errorMap[statusStr]
    }

    const matchKey = Object
        .keys(errorMap)
        .find(key => {
            const regex = new RegExp(key)
            return regex.test(statusStr)
        })

    if (!matchKey) {
        return errorMap[ALL]
    }

    return errorMap[matchKey]
}


// WEBPACK FOOTER //
// src/services/error-helper/index.js